exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-icon {\n  text-align: center;\n  font-size: 64px;\n  padding: 45px 0px 0px;\n  margin: 15px 0; }\n\n.status-check {\n  background: #FFFFF4; }\n  .status-check .status-icon {\n    color: #B8A81C; }\n\n.status-ok {\n  background: #fafffa; }\n  .status-ok .status-icon {\n    color: green; }\n\n.status-fail {\n  background: #fffafa; }\n  .status-fail .status-icon {\n    color: red; }\n\n.status-text {\n  text-align: center;\n  padding-bottom: 40px; }\n\n.ping-text {\n  font-size: .8em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/iws/vanenet/src/app/main/status/status.component.scss
// module id = ../../../../../src/app/main/status/status.component.scss
// module chunks = main.module